import { React, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import InvoiceForm from "./InvoiceForm";
import { Footer } from "../../components/componentsIndex";
import headerlogo from "../../assets/images/abc-logo.png";
import MenuIcon from "@mui/icons-material/Menu";
import PersonIcon from "@mui/icons-material/Person";
import LogoutIcon from "@mui/icons-material/Logout";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./dashboard.css";
import Loading from "../error/Loading";
import axios from "axios";
import { AuthAPI } from "../../services/dbApi";
import { AdminDashboard } from "../pagesIndex";
import { useSelector, useDispatch } from "react-redux";
import { setuser } from "../../state/features/userSlice";
import FeedbackForm from "../Feedback/FeedbackForm.jsx";
import TicketDashboard from "../Ticket/TicketDashboard.jsx";
import manualPDF from '../../assets/manual.pdf';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { zoomPlugin } from '@react-pdf-viewer/zoom';
import '@react-pdf-viewer/zoom/lib/styles/index.css';
import { InvoiceAPI } from "../../services/dbApi";

const MainContainer = () => {
    axios.defaults.withCredentials = true;
    //const userdetails = useSelector((state) => state.userdetails);
    //const userID = userdetails?.userData?.userID;

    const [activeMenu, setActiveMenu] = useState(true);
    const [screenSize, setScreenSize] = useState(null);
    const [currentTab, setCurrentTab] = useState(0);
    const [invoiceSuccess, setInvoiceSuccess] = useState({
        isInvoiceUploaded: "test",
        isDraft: "test",
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const navigate = useNavigate();

    const userdetails = useSelector((state) => state.userdetails);
    const dispatch = useDispatch();
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [isPDFModalOpen, setIsPDFModalOpen] = useState(false);
    const defaultLayoutPluginInstance = defaultLayoutPlugin();
    const zoomPluginInstance = zoomPlugin();
    const { CurrentScale, ZoomIn, ZoomOut } = zoomPluginInstance;

    const handleRFQSQRedirect = () => {
        window.open(
            "https://abcdl.payinvoice-uat.insideabc.com/#login",
            "_blank"
        );
    };
    const handleOpenPDF = (e) => {
        e.preventDefault();
        document.body.style.overflow = 'hidden';
        setIsPDFModalOpen(true);
    };

    const handleClosePDF = () => {
        setIsPDFModalOpen(false);
        document.body.style.overflow = 'auto';
    };
    const [showRFQSQ, setShowRFQSQ] = useState(false);

    useEffect(() => {
        if (userdetails?.userData?.userID) {
            getAllBusiness(userdetails.userData.userID);
        }
    }, [userdetails?.userData?.userID]);
    const getAllBusiness = async (partnerCode) => {
        try {
            const res = await InvoiceAPI.businessAll(partnerCode);

            console.log("partnerCode:", partnerCode);
            console.log("Business API Response:", res.data);

            const businessList = res?.data?.result || [];

            const hasABCDL = businessList.some(
                (item) => item.business_code === "ABCDL"
            );

            console.log("hasABCDL:", hasABCDL);

            setShowRFQSQ(hasABCDL);
        } catch (error) {
            console.error("Error fetching businesses", error);
            setShowRFQSQ(false);
        }
    };


    useEffect(() => {
        (async () => {
            try {
                setLoading(true);
                setError(false);
                const res = await AuthAPI.isAuth();
                if (res.data.valid) {
                    dispatch(
                        setuser({
                            userID: res?.data?.userID,
                            username: res?.data?.username,
                            business_code: userdetails.userData.company_title,
                        })
                    );
                    setTimeout(() => {
                        setLoading(false);
                    }, 3000);
                } else {
                    setTimeout(() => {
                        setLoading(false);
                        return navigate("/", { isnotify: 1 });
                    }, 3000);
                }
            } catch (error) {
                setError(true);
                setTimeout(() => {
                    setLoading(false);
                }, 3000);
                return navigate("/");
            }
        })();
    }, [navigate]);

    useEffect(() => {
        const handleResize = () => setScreenSize(window.innerWidth);
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if (screenSize < 1024) {
            setActiveMenu(false);
        } else {
            setActiveMenu(true);
        }
    }, [screenSize]);

    const ContentTab = [
        {
            title: "Dashboard",
            component: (
                <AdminDashboard
                    setSelectedInvoice={setSelectedInvoice}
                    invoiceSuccess={invoiceSuccess}
                    setCurrentTab={setCurrentTab}
                    currentTab={currentTab}
                    userID={userdetails.userData.userID}
                />
            ),
        },
        {
            title: "Invoice",
            component: (
                <InvoiceForm
                    userID={userdetails.userData.userID}
                    selectedInvoice={selectedInvoice}
                    setCurrentTab={setCurrentTab}
                    setInvoiceSuccess={setInvoiceSuccess}
                />
            ),
        },
        {
            title: "Feedback",
            component: (
                <FeedbackForm
                    userID={userdetails.userData.userID}
                />
            ),
        },
        {
            title: "Ticket",
            component: <TicketDashboard />,
        },
    ];

    const handleDelete = () => {
        AuthAPI.logout()
            .then(() => {
                navigate("/");
                localStorage.removeItem("token");
            })
            .catch((err) => console.log(err));
    };

    if (error) {
        return <h4>Network Error</h4>;
    }

    return loading ? (
        <Loading />
    ) : (
        <>
            <ToastContainer />
            <div className="header-container">
                <div className="header-main">
                    <div className="header-logo">
                        <img src={headerlogo} alt="Aditya Birla Capital" className="logo" />
                    </div>
                    <div className="header-right">
                        <div className="btn" onClick={handleOpenPDF} style={{ cursor: 'pointer' }}>
                            <MenuBookIcon />
                            <h5>User Manual</h5>
                        </div>
                        {isPDFModalOpen && (
                            <div className="pdf-modal-overlay" onClick={handleClosePDF}>
                                <div className="pdf-modal-content" onClick={(e) => e.stopPropagation()}>
                                    <div className="pdf-modal-header">
                                        <h3>Partner Portal Manual</h3>
                                        <button className="close-button" onClick={handleClosePDF}>
                                            ×
                                        </button>
                                    </div>
                                    <div className="pdf-modal-body">
                                        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                                            <div className="pdf-viewer-container">
                                                <div className="pdf-toolbar">
                                                    <ZoomOut />
                                                    <CurrentScale />
                                                    <ZoomIn />
                                                </div>
                                                <div className="pdf-viewer-wrapper"
                                                    onContextMenu={(e) => e.preventDefault()}>
                                                    <Viewer
                                                        fileUrl={manualPDF}
                                                        plugins={[zoomPluginInstance]}
                                                    />
                                                </div>
                                            </div>
                                        </Worker>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className="btn">
                            <PersonIcon />
                            <h5>{userdetails?.userData?.username}</h5>
                        </div>
                        <div className="btn">
                            <LogoutIcon onClick={handleDelete} />
                            <h5>Logout</h5>
                        </div>
                        <div
                            id="btn-toggle-menu"
                            onClick={() => {
                                setActiveMenu(!activeMenu);
                            }}
                        >
                            <MenuIcon />
                        </div>
                    </div>
                </div>
            </div>
            <main>
                {activeMenu && (
                    <aside>
                        <button
                            id="close-btn"
                            onClick={() => {
                                setActiveMenu(!activeMenu);
                            }}
                        >
                            <CloseRoundedIcon />
                        </button>
                        <div className="dashboard-sidebar">
                            {/* Sidebar menu, optionally list Dashboard and Upload Invoice */}
                            <div
                                className={currentTab === 0 ? "btn active" : "btn"}
                                onClick={() => {
                                    setCurrentTab(0);
                                    setSelectedInvoice(null);
                                }}
                            >
                                <span>Dashboard</span>
                                <ArrowForwardRoundedIcon />
                            </div>
                            <div
                                className={currentTab === 1 ? "btn active" : "btn"}
                                onClick={() => {
                                    setCurrentTab(1);
                                    setSelectedInvoice(null);
                                }}
                            >
                                <span>Upload Invoice</span>
                                <ArrowForwardRoundedIcon />
                            </div>


                            <div
                                className={currentTab === 3 ? "btn active" : "btn"}
                                onClick={() => {
                                    setCurrentTab(3);
                                    setSelectedInvoice(null);
                                }}
                            >
                                <span>Submit Request</span>
                                <ArrowForwardRoundedIcon />
                            </div>

                            <div
                                className={currentTab === 2 ? "btn active" : "btn"}
                                onClick={() => {
                                    setCurrentTab(2);
                                    setSelectedInvoice(null);
                                }}
                            >
                                <span>Feedback</span>
                                <ArrowForwardRoundedIcon />
                            </div>
                            {showRFQSQ && (
                                <div
                                    className="btn"
                                    onClick={handleRFQSQRedirect}
                                >
                                    <span>RFQ / SQ</span>
                                    <ArrowForwardRoundedIcon />
                                </div>
                            )}
                        </div>
                    </aside>
                )}
                <section className="stepper-invoice-container">
                    {ContentTab[currentTab].component}
                </section>
            </main>
            <Footer />
        </>
    );
};

export default MainContainer;
